// SpecRef: ARCH-005
// Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#9-schema-level-empty-data-detection
// v.check on data array raises @WARNING when backend returns zero active cases.
import * as v from 'valibot';

import { activeCaseSchema } from '#entities';

export const activeCasesResponseSchema = v.object({
  /** Array of active cases */
  data: v.pipe(
    v.array(activeCaseSchema),
    v.check(
      arr => arr.length > 0,
      '@WARNING: No active cases returned — backend may be unavailable or data is stale',
    ),
  ),
  /** Timestamp when the report was generated (ISO 8601) */
  dataGeneratedAt: v.string(),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});

export type ActiveCasesResponse = v.InferInput<
  typeof activeCasesResponseSchema
>;
